import owaEmptyState_lib_svg_Dark_illustration_moon_errorSvg from 'owa-empty-state/lib/svg/Dark/illustration_moon_error.svg';
import owaEmptyState_lib_svg_Light_illustration_moon_errorSvg from 'owa-empty-state/lib/svg/Light/illustration_moon_error.svg';
import EmptyState from 'owa-empty-state/lib/components/EmptyState';
import { getIsDarkTheme } from 'owa-fabric-theme';
import * as React from 'react';
import { observer } from 'mobx-react-lite';

let ERROR_STATE;
import styles from './AppHostErrorState.scss';

function initializeDisplayIconsForEmptyState() {
    if (getIsDarkTheme()) {
        ERROR_STATE = owaEmptyState_lib_svg_Dark_illustration_moon_errorSvg;
    } else {
        ERROR_STATE = owaEmptyState_lib_svg_Light_illustration_moon_errorSvg;
    }
}

export default observer(function AppHostErrorState() {
    initializeDisplayIconsForEmptyState();
    return (
        <EmptyState
            icon={ERROR_STATE}
            //TODO: 120056 App host loc strings
            mainMessage={'There was a problem reaching this app'}
            classNames={{
                container: styles.container,
            }}
            iconSize={160}
        />
    );
});
